import { mediaImageProps } from '@azoya-spa/contracts'

/**
 * Traduit un visuel en propriétés pour `MediaImage`, qu'il vienne du
 * back-office ou du repli embarqué à la compilation.
 *
 * Les deux ne se ressemblent pas : un média piloté porte un identifiant, ses
 * largeurs disponibles, un point focal et une origine déclarée ; une photo
 * embarquée n'est qu'un chemin et une description. On les ramène ici à la même
 * forme, pour que la page d'accueil n'ait pas à savoir d'où vient son image.
 */
export function proprietesVisuel(visuel, sizes) {
  if (!visuel) return null
  if (visuel.id && visuel.widths) return mediaImageProps(visuel, sizes)
  return {
    src: visuel.src,
    // Les photos embarquées ont désormais leurs propres largeurs, produites à
    // côté de la source par `scripts/genererVisuelsAccueil.mjs` (issue #142) :
    // avant elles, un téléphone téléchargeait la photo en pleine résolution,
    // 1,9 Mo pour un écran de 390 points, et le LCP mobile atteignait 15,2 s.
    //
    // `undefined` reste le sort d'une photo qui n'existe qu'en une taille : un
    // `srcset` vide vaudrait moins qu'absent, le navigateur y lirait une liste
    // de candidats dont aucun n'existe.
    srcSet: visuel.srcSet,
    sizes,
    alt: visuel.alt,
    objectPosition: '50% 50%',
    // Les trois photos embarquées sont authentiques : rien à signaler.
    disclosure: null,
  }
}

/**
 * Complète emplacement par emplacement, jamais en bloc.
 *
 * `useSiteContent` remplace sa valeur de repli dès que l'API répond — si cette
 * réponse ne contient aucun visuel (base pas encore amorcée), la page perdrait
 * ses trois photos d'un coup. Ce repli-ci se fait donc emplacement par
 * emplacement : l'API a le dernier mot quand elle a quelque chose à dire, et
 * la photo embarquée reste sinon.
 */
export function fusionnerAvecRepli(depuisApi, repli) {
  return {
    hero: depuisApi?.hero ?? repli.hero,
    jacuzzi: depuisApi?.jacuzzi ?? repli.jacuzzi,
    produits: depuisApi?.produits ?? repli.produits,
    // Aucune photo embarquée pour celle-ci : son absence garde la section
    // masquée, ce qui est l'état d'aujourd'hui.
    soinsSignature: depuisApi?.soinsSignature ?? repli.soinsSignature,
  }
}
